/**
 *  All api related to Stores
 */

import _ from 'lodash';
import { CancelToken } from 'axios';
import { OmnitechApi } from '../../api';
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchStore(options = {}) {
  const { id, cancelKey = 'fetchStore', ...others } = options
  const params = {
    id,
    ...others
  };
  const source = CancelToken.source()
  cancelRequest.add(
    cancelKey,
    () => source.cancel(`${cancelKey}: Operation cancelled by user`)
  )

  return OmnitechApi
    .request({
      endpoint: `stores/${id}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      store: data.store
    }))
};

export function fetchStoreByCode(options = {}) {
  const { code, cancelKey = 'fetchStoreByCode', ...others } = options
  const params = {
    code,
    ...others
  };
  const source = CancelToken.source()
  cancelRequest.add(
    cancelKey,
    () => source.cancel(`${cancelKey}: Operation cancelled by user`)
  )

  return OmnitechApi
    .request({
      endpoint: `stores/by_code/${code}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      store: data.store
    }))
};

export function fetchStores(options = {}) {
  const { page = 1, cancelKey = 'fetchStores', ...others } = options
  const params = {
    page,
    ...others
  };
  const source = CancelToken.source()
  cancelRequest.add(
    cancelKey,
    () => source.cancel(`${cancelKey}: Operation cancelled by user`)
  )

  return OmnitechApi
    .request({
      endpoint: `stores`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      stores: data.stores,
      next: _.get(data, 'storesPagination.nextPage') > page
        ? () => fetchStores({
          ...options,
          page: page + 1,
        })
        : null,
      count: _.get(data, 'storesPagination.totalCount'),
      cacheChecksum: _.get(cacheChecksum, 'storesValue'),
    }))
};

export function fetchStoreDateTimeInformation({
  id, // storeId
  date, // information date;
  cancelKey = 'fetchStoreDateTimeInformation',
} = {}) {

  if (_.isEmpty((id || '').toString())) {
    console.error('fetchStoreDateTimeInformation: missing parameter "id"')
    return Promise.reject()
  }
  const source = CancelToken.source()
  cancelRequest.add(
    cancelKey,
    () => source.cancel(`${cancelKey}: Operation cancelled by user`)
  )
  cancelRequest.add(
    `${cancelKey}.${id}`,
    () => source.cancel(`${cancelKey}.${id}: Operation cancelled by user`)
  )

  return OmnitechApi
    .request({
      endpoint: `stores/${id}/date_time_information`,
      method: 'get',
      params: {
        date,
      },
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      dateTimeInformation: _.get(data, `dateTimeInformation.${_.camelCase(date)}`),
    }))
}
